var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpenBook = function SvgOpenBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1.46h-.73V.73a.73.73 0 0 0-.73-.73h-4.622C11.724 0 10.665.58 10 1.469A3.642 3.642 0 0 0 7.08 0H2.46a.73.73 0 0 0-.73.73v.73h-.73a.73.73 0 0 0-.73.73v15.08c0 .403.327.73.73.73h18a.73.73 0 0 0 .73-.73V2.19a.73.73 0 0 0-.73-.73Zm-15.812 0H7.08c1.207 0 2.19.982 2.19 2.189V14.35a.73.73 0 0 0 1.459 0V3.65c0-1.207.982-2.19 2.19-2.19h3.891v13.622h-3.892A3.64 3.64 0 0 0 10 16.556a3.64 3.64 0 0 0-2.919-1.475H3.188V1.46Z",
    fill: "#BFC3D1"
  })));
};

export default SvgOpenBook;